import { Box, Layout } from '@wix/design-system'
import React, { FC } from 'react'

export const OptionsContainer: FC = ({ children }) => {
  return (
    <Box width="685px" direction="vertical">
      <Layout gap="SP8" rowHeight="278px">
        {children}
      </Layout>
    </Box>
  )
}
